﻿export interface IGridPagingOptionsModel {
    pageNumber: number;
    pageSize: number;
    recordCount: number;
    pageCount: number;
}

export class GridPagingOptionsModel {
    pageNumber: number;
    pageSize: number;
    recordCount: number;
    pageCount: number;
}